package com.anjuros.website.redesign.sections.designs

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for the Designs page: the list of designs, the breadcrumb and the FAQ. */
@Composable
fun designsStructuredData(): String {
    val name = LocalText(RdText.DESIGNS_HERO_TITLE_START) + LocalText(RdText.DESIGNS_HERO_TITLE_MARK)
    val items = AllDesigns
        .map { LocalText(it.title) to it.path }
        .mapIndexed { index, (title, path) ->
            """{"@type":"ListItem","position":${index + 1},"name":${jsonString(title)},"url":"$SITE_URL$path"}"""
        }
        .joinToString(",")
    val breadcrumb = rdBreadcrumbJsonLd(RdText.DESIGNS_CRUMB, RdRoute.DESIGNS)
    val faq = rdFaqJsonLd(DesignsFaqs)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"CollectionPage","url":"$SITE_URL${RdRoute.DESIGNS}","name":${jsonString(name)},
          "provider":{"@id":"$SITE_URL/#business"},
          "mainEntity":{"@type":"ItemList","itemListElement":[$items]}},
         $breadcrumb,
         $faq
        ]}
    """.trimIndent()
}
